/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMemo } from 'react';
import {
    ISubmitPreQualificationApplicationV2Body,
    ISubmitResponse,
} from '../../../../../../../types/shared/PrequalificationDataEntry';
import { acquisitionApiRequest } from '../../../../../../../utils/acquisition-api/AcquisitionApi';
import { getMarketingAttributesForAcquisitions } from '../../../../../../../utils/acquisition-utils';
import SessionStorage from '../../../../../../../utils/SessionStorage';
import usePersonalInformationForSubmit from './hooks/usePersonalInformation';

export default function useAcquisitionSubmitAPI() {
    const { PersonalInformation } = usePersonalInformationForSubmit();
    
    //Extracts out unneeded fields from Personal Info 
    const {
        Ssn,
        IsDataEntryPage,
        DOBDay,
        DOBMonth,
        DOBYear,
        DateOfBirth,
        PrimaryPhoneNumber,
        SecondaryPhoneNumber,
        ioBlackBox,
        fpBB,
        ...PersonalInformationPqBrowserChannel
    } = PersonalInformation;

    const acquistionsSubmit = async () => {
        await SessionStorage.setCipher(
            'PersonalInfoBrowserChannel', 
            PersonalInformationPqBrowserChannel,
        );
        const body = {
            PersonalInformation,
            MarketingAttributes: getMarketingAttributesForAcquisitions(),
        } as ISubmitPreQualificationApplicationV2Body;

        return await acquisitionApiRequest<ISubmitResponse>(
            'pre-qualification-submit-v2',
            {
                method: 'POST',
                body,
            },
        );
    };

    return {
        acquistionsSubmit,
    };
}
